import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

// Protect Route
import ProtectedRoute from "./components/ProtectedRoute";
// Page Import
import ForgotPassword from "./components/pages/forgotPassword";
import ResetPassword from "./components/pages/resetPassword";
import Login from "./components/pages/login";
import SelectRegister from "./components/pages/register/selectregister";
import Register from "./components/pages/register";
import SchoolRegister from "./components/pages/register/schoolregister";
import SchoolEdit from "./components/pages/register/schooledit";
import TeacherRegister from "./components/pages/register/teacherregister";
import IndividualTeacherRegister from "./components/pages/register/individualteacherregister";
import Card from "./components/payment/card";

import NotFound from "./components/pages/error/notfound";
//Home
import Include from "./components/include";
import AboutUs from "./components/aboutUs";
import Testimonial from "./components/testimonial";
import Faq from "./components/faq";
import GetCertified from "./components/getCertified";
import CareGiver from "./components/careGiver";

// Admin
import AdminDashboard from "./components/admin/dashboard";
import AdminCourse from "./components/admin/course";
import AddCourse from "./components/admin/addCourse";
import TeacherLists from "./components/admin/teacherList";
import SchoolLists from "./components/admin/schoolList";
import SchoolTeacherList from "./components/admin/schoolTeacher";
import InfluenceList from "./components/admin/influenceList";
// School
import SchoolDashboard from "./components/school/dashboard";
import SchoolOrderHistory from "./components/school/orderhistory";
import AddSchoolTeacher from "./components/school/teacher";
import MyTeachers from "./components/school/myteachers";
import ViewAction from "./components/school/viewAction";
import EditTeacher from "./components/school/editTeacher"
// School Teacher
import SchoolTeacherDashboard from "./components/schoolteacher/dashboard";

// Individual Teacher
import TeacherDashboard from "./components/teacher/dashboard";
import TeacherOrderHistory from "./components/teacher/orderhistory";
import Test from "./components/test";
import TeacherTest from "./components/teachertest";
import { Home } from "./components/home";
import {
  CertificateList,
  ViewCertificate,
  StaticCertificatetest,
  AutoDownloadCertificate,
} from "./components/certification";

const Approuter = () => {
  return (
    <AuthProvider>
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/testimonial" element={<Testimonial/>} />
          <Route path="/aboutUs" element={<AboutUs />}/>
          <Route path="/getCertified" element={<GetCertified/>}/>
          <Route path="/faq" element={<Faq/>}/>
          <Route path="/include" element={<Include/>}/>
          <Route path="careGiver" element={<CareGiver/>}/>
          <Route path="/selectregister" element={<SelectRegister />} />
          <Route path="/register/:type" element={<Register />} />
          <Route path="/schoolregister/:type" element={<SchoolRegister />} />
          <Route path="/individualteacherregister" element={<IndividualTeacherRegister/>} />
          <Route path="/schooledit/:school_id" element={<SchoolEdit />} />
          <Route path="/teacherregister/:type" element={<TeacherRegister />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/test/mcq-test" element={<Test />} />
          <Route path="/teachertest/mcq-test" element={<TeacherTest />} />
          <Route path="/viewaction" element={<ViewAction />} />
          <Route path="/certificates" element={<CertificateList />} />
          <Route
            path="/all-certificates/:teacher_id"
            element={<CertificateList />}
          />
          <Route
            path="/viewcertificate/:userid/:type"
            element={<ViewCertificate />}
          />
          <Route
            path="/certificate/:userid/:type"
            element={<AutoDownloadCertificate />}
          />
          <Route
            path="/emergencycertificate/:userid"
            element={<StaticCertificatetest />}
          />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          {/* <Route path="/card" element={<Card />} /> */}
          <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
            <Route path="/admin/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/admin/admin-courses" element={<AdminCourse />} />
            <Route path="/add-course" element={<AddCourse />} />
            <Route path="/admin/teachers-lists" element={<TeacherLists />} />
            <Route
              path="/admin/school-teacher-list/:school_id"
              element={<SchoolTeacherList />}
            />
            <Route path="/admin/school-lists" element={<SchoolLists />} />
            <Route path="/admin/influences" element={<InfluenceList />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
            <Route path="/school-dashboard" element={<SchoolDashboard />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
            <Route
              path="/school-order-history"
              element={<SchoolOrderHistory />}
            />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
            <Route path="/add-school-teacher" element={<AddSchoolTeacher />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
            <Route path="/my-teachers" element={<MyTeachers />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
            <Route path="/editTeacher" element={<EditTeacher />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["2"]} />}>
            <Route
              path="/schoolteacher-dashboard"
              element={<SchoolTeacherDashboard />}
            />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["3"]} />}>
            <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["3"]} />}>
            <Route
              path="/teacher-order-history"
              element={<TeacherOrderHistory />}
            />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default Approuter;
